// Legacy WordPress URL: /portfolio → /case-studies (301).
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/portfolio")({
  beforeLoad: () => {
    throw redirect({ to: "/case-studies", statusCode: 301 });
  },
});
